import isEvent from './isEvent';

const getSelectedValues = (options) => {
  const result = [];
  if (options) {
    for (let index = 0; index < options.length; index++) {
      const option = options[index];
      if (option.selected) {
        result.push(option.value);
      }
    }
  }
  return result;
};

const getValue = (event) => {
  if (isEvent(event) || event?.target) {
    const {
      target: { type, value, checked },
    } = event;
    if (type === 'checkbox') {
      return checked;
    }
    if (type === 'text' && value === '') {
      return null;
    }
    return value;
  }
  return event;
};

export default getValue;
